import { Client } from "@/Common/Api/Client";
import { IRepresentantsDto } from "@/Common/Api/Patient/Dto/IRepresentantsDto";
import * as ServerOperations from "@/Common/Operations/operations.server";

class RepresentantHelper {
    public static async getPatientRepresentants(
        patientContactId: string
    ): Promise<IRepresentantsDto> {
        const response = await Client.postAsync<IRepresentantsDto>(
            ServerOperations.Server.Myle_Patient_Representant_GetAll,
            { PatientContactId: patientContactId }
        );

        return response.data;
    }
}

export { RepresentantHelper };
